import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./DocumentProgressBarPopup.module.css";

export function DocumentProgressBarPopup(props: { maxValue: number, currentValue: number }): JSX.Element {
    const { getText } = useTranslation();

    return (
        <div className={styles.background}>
            <div className={styles.container}>
                <div className={styles.message}>{getText("GeneratingDocumentPleaseWaitLabel")}</div>
                <div>
                    {props.currentValue}/{props.maxValue}
                </div>
                <progress
                    className={styles.bar}
                    value={props.currentValue}
                    max={props.maxValue}
                >
                    {props.currentValue / props.maxValue}%
                </progress>
            </div>
        </div>
    );
}
